import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-change",
  "use": "icon-change-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-change\">\n    <title>icon/基础图标/切换</title>\n    <g id=\"icon-change_icon/基础图标/切换\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\">\n        <path d=\"M74.1629056,74.1629056 C67.4673444,80.8586722 58.2173444,85 48,85 C27.5655167,85 11,68.4344833 11,48 C11,27.5655167 27.5655167,11 48,11 C58.2173444,11 67.4673444,15.1413689 74.1629056,21.8370944 C77.5710167,25.2452056 85,33.6111111 85,33.6111111\" id=\"icon-change_路径\" stroke=\"currentColor\" stroke-width=\"10\" />\n        <polyline id=\"icon-change_路径\" stroke=\"currentColor\" stroke-width=\"10\" stroke-linecap=\"square\" points=\"85 16 85 34 67 34\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/change.svg
// module id = Ufd9
// module chunks = 3